import React, { PropsWithChildren, ReactElement, ReactNode } from 'react';
import { Box } from '@clariness/box';
import { Flex } from '@clariness/flex';
import { StyleObject } from '@clariness/base';
import { Text } from '@clariness/clarikit-react';
import { LabeledContentTable } from './components';

type LabeledContentProps = {
  label: string | ReactNode;
  sx?: StyleObject;
  icon?: ReactElement;
  action?: ReactNode;
};

export const LabeledContent = ({
  label,
  icon,
  action,
  sx,
  children,
}: PropsWithChildren<LabeledContentProps>) => {
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        gap: '8px',
        width: '100%',
        ...sx,
      }}
    >
      <Flex
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Flex sx={{ alignItems: 'center' }}>
          <Text as="h6" variant="headingXs">
            {label}
          </Text>

          {icon}
        </Flex>
        {action}
      </Flex>

      <Box
        as="hr"
        sx={{
          width: '100%',
          border: 'none',
          borderBottom: '1px solid #CECECE',
        }}
      />

      {children}
    </Flex>
  );
};

LabeledContent.Table = LabeledContentTable;
